import {IntermediatePart} from "../../intermediatePart";
import {LayoutType} from "../../constants";

export default class DecorWindow extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = "decor_window";
    this.partName = "Decor Window";
    if (isChild) {
      this.showOnLayouts = [LayoutType.Layout4];
    }
  }

  load(dbFeature) {
    return super.load_(dbFeature, new DecorWindow());
  }

  setLayers(layout) {
    if (!this.showOnLayouts.includes(layout.type)) {
      super.hideLayers();
      return;
    }
    super.setLayers(layout);
  }

  setZIndex(zIndexes) {
    if (zIndexes && this.activeFeature) {
      this.activeFeature.layer.zIndex = zIndexes.Globals.DecorWindow;
    }
  }
}
